import OnScreen from 'onscreen';

( function Scrolling( $ ) {

    initLocalScroll();
    initVisibilities();


    /**
      * Visibilities based on scollling.
      */
    function initVisibilities() {

      const elements = document.querySelectorAll( '[data-reveal]' );

      if( ! elements.length ) {
        return;
      }

      $( window ).on( 'scroll', () => {

        const scroll_top = window.scrollY;
        const window_height = window.innerHeight;

        for( let element of elements ) {

          const args = JSON.parse( element.dataset.reveal );
          const $element = $(element);
          const position = $element.offset();
          const offset = ( args.offset || 0 );

          // Reveal based on distance from top.
          if( args.type == 'from-top' ) {

            if(
                position.top <= scroll_top + offset &&
                ! $element.hasClass( 'is-showing' )
            ) {
              $element.removeClass( 'is-hidden' );
              $element.addClass( 'is-showing' );
            }
            else if( position.top > scroll_top + offset ) {

              $element.removeClass( 'is-showing' );
              $element.addClass( 'is-hidden' );

            }





          }


        }


      })



    }


    /**
     * Local Scrolls
     */

    function initLocalScroll()  {

        const $local_triggers = document.querySelectorAll( '[data-js-local-scroll]' );

        for( let $trigger of $local_triggers ) {

            $trigger.addEventListener( 'click', ( event ) => {
                event.preventDefault();

                console.log( event );

                let section = event.target.closest( '[data-js-local-scroll]' ).getAttribute( 'href' );

                $('html, body').animate( {

                    scrollTop: $(section).offset().top

                }, 300 );

            } );


        }
    }





} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/scrolling.js